import { useState } from 'react'
import { Button, Container, Form, FormControl, InputGroup, Modal, Row, Spinner, Col } from 'react-bootstrap'
import ApiService from '../../../ApiService'

export default function ReassignModal({ handleClose, kit, recordType, onRefresh }) {
  const [reassignData, setReassignData] = useState({
    kitId: kit,
    reason: '',
    ack1: null,
    ack2: null,
    ack3: null,
  })

  const changeReassignData = (field, value) => {
    setReassignData({ ...reassignData, [field]: value })
  }

  const reassignToMeFunc = async () => {
    const isInvalid = !reassignData?.reason || !reassignData?.kitId || !reassignData?.ack1 || !reassignData?.ack2 || !reassignData?.ack3
    if (isInvalid) {
      alert('Please confirm and select all checkboxes')
      return
    }
    try {
      if (recordType === 'LAB_RESULT') {
        const r = await ApiService.putAssignLabResult({ kitId: reassignData.kitId, reason: reassignData.reason })
        onRefresh && onRefresh()
      } else if (recordType === 'LAB_REQUEST') {
        const r = await ApiService.putAssignLabRequest({ kitId: reassignData.kitId, reason: reassignData.reason })
        onRefresh && onRefresh()
      } else {
        throw new Error(`Unsupported record type: ${recordType}`)
      }
    } catch (error) {
      const msg = error?.response?.data?.message ?? error?.message;
      alert(msg);
      console.error(error)
    } finally {
      handleClose()
    }
  }

  return (
    <Modal size="lg" show={true} onHide={() => handleClose()} backdrop={'static'}>
      <Modal.Header>
        <Modal.Title>Re-assign Kit {reassignData?.kitId} to Me</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Form.Group
            as={Col}
            controlId="formBookingId"
            style={{
              marginBottom: 15,
              width: '100%',
            }}
          >
            <Form.Label id="cardFormLabel" column sm={8}>
              Reason for Re-assignment <span style={{ color: 'red' }}>*</span>
            </Form.Label>
            <Col>
              <Form.Control
                type="textarea"
                as="textarea"
                row={3}
                placeholder="Type Reason for Re-assignment"
                aria-label="Reason for Re-assignment"
                aria-describedby="basic-addon1"
                onChange={e => changeReassignData('reason', e.target.value)}
              />
            </Col>
          </Form.Group>
        </Row>
        <Col>
          <Form.Group
            as={Row}
            controlId="formBookingId"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 15,
            }}
          >
            {/* <Form.Label id="cardFormLabel" column sm={8}>
              I acknowledge to review the patient profile, internal and external notes before taking any action <span style={{ color: 'red' }}>*</span>
            </Form.Label> */}
            <Col>
              <Form.Check
                inline
                label="Please review the patient's profile, any internal notes, and messages before releasing results"
                type="switch"
                id="custom-switch"
                aria-label="ack 1"
                aria-describedby="basic-addon1"
                onChange={e => changeReassignData('ack1', e.target.value === 'on' ? true : false)}
                style={{ width: '100%' }}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group
            as={Row}
            controlId="formBookingId"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 15,
            }}
          >
            {/* <Form.Label id="cardFormLabel" column sm={8}>
              I will ensure no prior actions like approval will be done again <span style={{ color: 'red' }}>*</span>
            </Form.Label> */}
            <Col>
              <Form.Check
                inline
                label="I will ensure no prior actions like approval will repeated"
                type="switch"
                id="custom-switch"
                aria-label="ack 2"
                aria-describedby="basic-addon1"
                onChange={e => changeReassignData('ack2', e.target.value === 'on' ? true : false)}
                style={{ width: '100%' }}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group
            as={Row}
            controlId="formBookingId"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 15,
            }}
          >
            {/* <Form.Label id="cardFormLabel" column sm={8}>
              I will ensure that any pending patient messages are responded in timely manner. <span style={{ color: 'red' }}>*</span>
            </Form.Label> */}
            <Col style={{ width: '100%' }}>
              <Form.Check
                inline
                label="I will ensure that any pending patient messages are responded in timely manner."
                type="switch"
                id="custom-switch"
                aria-label="ack 3"
                aria-describedby="basic-addon1"
                onChange={e => changeReassignData('ack3', e.target.value === 'on' ? true : false)}
                style={{ width: '100%' }}
              />
            </Col>
          </Form.Group>
        </Col>
      </Modal.Body>
      <Modal.Footer>
        <button 
          class="btn btn-light" 
          onClick={handleClose}>
          Cancel
        </button>
        <Button
          id="msg_reply" 
          class="btn btn-primary"
          onClick={reassignToMeFunc}
          disabled={!reassignData?.reason || !reassignData?.kitId || !reassignData?.ack1 || !reassignData?.ack2 || !reassignData?.ack3}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
